import { filter } from 'rxjs';

const filterNil = () => filter((value) => value !== undefined && value !== null);

/**
 * Generated bundle index. Do not edit.
 */

export { filterNil };
